import React, { Component } from "react";

class TerminalWindow extends Component {
  render() {
    return (
      <div className="terminal terminal-space terminal-shadow">
        <div className="top">
          <div className="btns">
            <span className="circle terminal-red"></span>
            <span className="circle terminal-yellow"></span>
            <span className="circle terminal-green"></span>
          </div>
          <div className="terminal-title">{this.props.title}</div>
        </div>
        <div className="terminal-output">
          <code>{this.props.output}</code>
        </div>
      </div>
    );
  }
}

export default TerminalWindow;
